
import React,{useState} from "react";
import {Link } from "react-router-dom";

const TextArea= ({onchange,placeholder,name,value,baseUrl ,title,words}) =>{
    
 const [valueInput , setValueInput] = useState({val:value});
return(
    <div  className="popup-backgrop">
      <div  className="popup-card">
        <div  className="blank"> </div>
    <div  className="popup-outer">
 <div  className="popup-inner"> 
 
    <div  className="login-signup-left-signup"><h1 style={{"textAlign":"center"}}>Update {name} </h1>
    <div  className="popup-input-card"><div  ></div>
    <textarea type="text" cols={5} rows={5} placeholder={placeholder} className="input-textbox" title={title} value={valueInput.val?valueInput.val:setValueInput({...valueInput ,val:"Info: "})} name={name}  
     onChange={e=>{
        if(valueInput.val.match(/\w+/gim)?.length<words.count )
        setValueInput({...valueInput ,val:e.target.value});
       
       
        
       }
      
      
       
    }
    onChangeCapture={onchange }
    />
    <div></div>
<div id="word-count" className="input-textbox"> {valueInput.val ? valueInput.val.match(/\w+/gim)?.length : 0} words / {words.count} words</div>

    </div>
    
    <div  className="popup-button-card">
      <button  className="green-button" type="submit" id="signupBtn">{value?"Update":"Add"}</button>
  
  <Link to={baseUrl} className="black-button">
close
 </Link>
  
  </div>
  </div>
   </div>
   
   </div>
	    
	</div></div>

)

}

export default TextArea;

